import { theme as LightTheme } from '../../themes/LightTheme'
import { WhitelabelThemeOverride } from '../../themes/overrides/WhitelabelThemeOverride'

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'

export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

export const URL_PATTERN = /^(https?:\/\/)((([a-z0-9-]+\.)+[a-z]{2,})|localhost)(:[0-9]{1,5})?(\/\S*)?$/i

export const HEX_PATTERN = /^#[0-9A-F]{6}$/i

export const CLEAR_DATE = '0001-01-01T00:00:00+00:00'

export const RESELLERS = {
    libellula: {
        name: 'libellula',
        title: 'Libellula.QUOTATION',
        theme: WhitelabelThemeOverride,
        logo: 'libellula-logo.png',
        organisationUnits: 'metric',
        selectedLanguage: 'it-IT',
        organisationLocale: 'it-IT',
        organisationCurrencyCode: 'EUR',
        hasWebStoreAccess: false,
    },
    striker: {
        name: 'striker',
        title: 'Striker Quote',
        theme: WhitelabelThemeOverride,
        logo: 'striker-logo.png',
        organisationUnits: 'metric',
        selectedLanguage: 'en-US',
        organisationLocale: 'en-US',
        organisationCurrencyCode: 'USD',
        hasWebStoreAccess: false,
    },
}

export const QUOTE_SOURCE_TYPES = {
    Internal: 'Internal',
    WebStore: 'Web Store',
}

export const SHIPPING_OPTIONS = [
    {
        value: 'Pickup',
        label: 'Pickup',
    },
    {
        value: 'Delivery',
        label: 'Delivery',
    },
]

export const PUBLIC_DOCUMENTS = {
    Quote: 'quote',
    OrderConfirmation: 'order-confirmation',
    ProformaInvoice: 'proforma',
    TaxInvoice: 'tax-invoice',
}

export const PRIVATE_DOCUMENTS = {
    WorkOrderSummary: 'work-order-summary',
    WorkOrder: 'work-order',
    DeliveryDocket: 'delivery-docket',
    ProductionLabels: 'production-labels',
}

export const PRODUCT_DETAILS = {
    name: 'toolbox',
    title: 'ToolBox',
    theme: LightTheme,
    logo: 'app-logo.svg',
    organisationUnits: 'imperial',
    selectedLanguage: 'en-US',
    organisationLocale: 'en-US',
    organisationCurrencyCode: 'USD',
    hasWebStoreAccess: true,
}

export const WEB_STORE_QUOTE_STATUS = {
    NotCalculated: 'NotCalculated',
    Calculated: 'Calculated',
    Ordered: 'Ordered',
    Invoiced: 'Invoiced',
    Dispatched: 'Dispatched',
    Lost: 'Lost',
    Cancelled: 'Cancelled',
    PendingOrderConfirmation: 'PendingOrderConfirmation',
    Rejected: 'Rejected',
    Voided: 'Voided',
    Issued: 'Issued',
}

export const QUOTE_STATUS_ARRAY = {
    NotCalculated: 'NotCalculated',
    Calculated: 'Calculated',
    Draft: 'Draft',
    Issued: 'Issued',
    Ordered: 'Ordered',
    Invoiced: 'Invoiced',
    Lost: 'Lost',
    Cancelled: 'Cancelled',
    PendingOrderConfirmation: 'PendingOrderConfirmation',
    Rejected: 'Rejected',
    Voided: 'Voided',
    Dispatched: 'Dispatched',
}

export const QUOTE_STATUS_MAP = {
    NotCalculated: { index: 0, label: 'Editing' },
    Calculated: { index: 0, label: 'Editing' },
    Draft: { index: 1, label: 'Draft' },
    Issued: { index: 2, label: 'Issued' },
    PendingOrderConfirmation: { index: 3, label: 'Pending Confirmation' },
    Ordered: { index: 4, label: 'Ordered' },
    Invoiced: { index: 5, label: 'Invoiced' },
    Lost: { index: 6, label: 'Lost' },
    Rejected: { index: 7, label: 'Rejected' },
    Cancelled: { index: 8, label: 'Cancelled' },
    Voided: { index: 9, label: 'Voided' },
    Dispatched: { index: 10, label: 'Dispatched' },
}

export const QUOTE_PAYMENT_STATUS = {
    Unpaid: 'Unpaid',
    ManualPaid: 'ManualPaid',
    GatewayPaid: 'GatewayPaid',
}

export const QUOTE_PAYMENTS_STATUS_LABEL = {
    Unpaid: 'Unpaid',
    ManualPaid: 'Paid',
    GatewayPaid: 'Paid via Stripe',
}

export const QUOTE_INTEGRATION_STATUS = {
    NotExported: 'NotExported',
    Processing: 'Processing',
    Exported: 'Exported',
}

export const QUOTE_INTEGRATION_STATUS_LABEL = {
    NotExported: 'Error',
    Processing: 'Processing',
    Exported: 'Exported',
}

export const GET_STATUS_LABEL = (status) => {
    return QUOTE_STATUS_MAP[status]?.label || 'Unknown'
}

export const GET_PAYMENT_STATUS_LABEL = (status) => {
    if (status) {
        return QUOTE_PAYMENTS_STATUS_LABEL[status]
    }
    return QUOTE_PAYMENTS_STATUS_LABEL.Unpaid
}

export const QUOTE_ACTIONS = {
    reviewQuote: {
        id: 'reviewQuote',
        label: 'Review quote',
        handler: 'handleQuoteStatusChange',
        param: QUOTE_STATUS_ARRAY.Draft,
        tagAttrs: { 'data-testid': 'review-quote-button' },
    },
    calculateQuote: {
        id: 'calculateQuote',
        label: 'Calculate',
        handler: 'handleCalculateQuote',
        tagAttrs: { 'data-testid': 'calculate-quote-button' },
    },
    editQuote: {
        id: 'editQuote',
        label: 'Edit quote',
        handler: 'handleQuoteStatusChange',
        param: QUOTE_STATUS_ARRAY.Calculated,
        tagAttrs: { 'data-testid': 'edit-quote-button' },
    },
    editPendingOrder: {
        id: 'editPendingOrder',
        label: 'Edit pending order',
        handler: 'handleQuoteStatusChange',
        param: QUOTE_STATUS_ARRAY.Calculated,
        tagAttrs: { 'data-testid': 'edit-pending-order-button' },
    },
    markAsIssued: {
        id: 'markAsIssued',
        label: 'Mark as issued',
        handler: 'handleQuoteStatusChange',
        param: QUOTE_STATUS_ARRAY.Issued,
        tagAttrs: { 'data-testid': 'mark-as-issued-button' },
    },
    markAsOrdered: {
        id: 'markAsOrdered',
        label: 'Mark as ordered',
        handler: 'handleMarkAsOrdered',
        tagAttrs: { 'data-testid': 'mark-as-ordered-button' },
    },
    markAsLost: {
        id: 'markAsLost',
        label: 'Mark as lost',
        handler: 'handleQuoteStatusChange',
        param: QUOTE_STATUS_ARRAY.Lost,
        tagAttrs: { 'data-testid': 'mark-as-lost-button' },
    },
    markAsInvoiced: {
        id: 'markAsInvoiced',
        label: 'Mark as invoiced',
        handler: 'handleMarkAsInvoiced',
        tagAttrs: { 'data-testid': 'mark-as-invoiced-button' },
    },
    markAsCancelled: {
        id: 'markAsCancelled',
        label: 'Mark as cancelled',
        handler: 'handleQuoteStatusChange',
        param: QUOTE_STATUS_ARRAY.Cancelled,
        tagAttrs: { 'data-testid': 'mark-as-cancelled-button' },
    },
    markAsVoided: {
        id: 'markAsVoided',
        label: 'Mark as voided',
        handler: 'handleQuoteStatusChange',
        param: QUOTE_STATUS_ARRAY.Voided,
        tagAttrs: { 'data-testid': 'mark-as-voided-button' },
    },
    markAsConfirmed: {
        id: 'markAsConfirmed',
        label: 'Confirm pending order',
        handler: 'handleMarkAsOrdered',
        tagAttrs: { 'data-testid': 'mark-as-confirmed-button' },
    },
    markAsRejected: {
        id: 'markAsRejected',
        label: 'Reject pending order',
        handler: 'handleQuoteStatusChange',
        param: QUOTE_STATUS_ARRAY.Rejected,
        tagAttrs: { 'data-testid': 'mark-as-rejected-button' },
    },
    markAsPending: {
        id: 'markAsPending',
        label: 'Revert to pending order',
        handler: 'handleQuoteStatusChange',
        param: QUOTE_STATUS_ARRAY.PendingOrderConfirmation,
        tagAttrs: { 'data-testid': 'mark-as-pending-button' },
    },
    markAsPaid: {
        id: 'markAsPaid',
        label: 'Mark as paid',
        handler: 'handleQuotePaymentStatusChange',
        param: QUOTE_PAYMENT_STATUS.ManualPaid,
        tagAttrs: { 'data-testid': 'mark-as-paid-button' },
        hidden: (showPayments) => !showPayments,
    },
    markAsPaidAndOrdered: {
        id: 'markAsPaidAndOrdered',
        label: 'Mark as paid and ordered',
        handler: 'handleMarkAsPaidAndOrdered',
        param: QUOTE_PAYMENT_STATUS.ManualPaid,
        tagAttrs: { 'data-testid': 'mark-as-paid-and-ordered-button' },
        hidden: (showPayments) => !showPayments,
    },
    markAsUnpaid: {
        id: 'markAsUnpaid',
        label: 'Mark as unpaid',
        handler: 'handleQuotePaymentStatusChange',
        param: QUOTE_PAYMENT_STATUS.Unpaid,
        tagAttrs: { 'data-testid': 'mark-as-unpaid-button' },
        hidden: (showPayments) => !showPayments,
    },
    copyQuoteLink: {
        id: 'copyQuoteLink',
        label: 'Copy quote link',
        handler: 'handleCopyLink',
        param: PUBLIC_DOCUMENTS.Quote,
        tagAttrs: { 'data-testid': 'copy-quote-link-button' },
    },
    copyOrderLink: {
        id: 'copyOrderLink',
        label: 'Copy order confirmation link',
        handler: 'handleCopyLink',
        param: PUBLIC_DOCUMENTS.OrderConfirmation,
        tagAttrs: { 'data-testid': 'copy-order-link-button' },
    },
    copyProformaLink: {
        id: 'copyProformaLink',
        label: 'Copy proforma invoice link',
        handler: 'handleCopyLink',
        param: PUBLIC_DOCUMENTS.ProformaInvoice,
        tagAttrs: { 'data-testid': 'copy-proforma-link-button' },
    },
    copyInvoiceLink: {
        id: 'copyInvoiceLink',
        label: 'Copy invoice link',
        handler: 'handleCopyLink',
        param: PUBLIC_DOCUMENTS.TaxInvoice,
        tagAttrs: { 'data-testid': 'copy-invoice-link-button' },
    },
    emailQuote: {
        id: 'emailQuote',
        label: 'Email quote',
        handler: 'handleSendEmail',
        param: PUBLIC_DOCUMENTS.Quote,
        tagAttrs: { 'data-testid': 'email-quote-button' },
    },
    emailOrder: {
        id: 'emailOrder',
        label: 'Email order confirmation',
        handler: 'handleSendEmail',
        param: PUBLIC_DOCUMENTS.OrderConfirmation,
        tagAttrs: { 'data-testid': 'email-order-button' },
    },
    emailProformaInvoice: {
        id: 'emailProformaInvoice',
        label: 'Email proforma invoice',
        handler: 'handleSendEmail',
        param: PUBLIC_DOCUMENTS.ProformaInvoice,
        tagAttrs: { 'data-testid': 'email-proforma-invoice-button' },
    },
    emailTaxInvoice: {
        id: 'emailTaxInvoice',
        label: 'Email tax invoice',
        handler: 'handleSendEmail',
        param: PUBLIC_DOCUMENTS.TaxInvoice,
        tagAttrs: { 'data-testid': 'email-tax-invoice-button' },
    },
    emailCustomer: {
        id: 'emailCustomer',
        label: 'Email customer',
        handler: 'handleSendEmail',
        param: 'sendCustomer',
        tagAttrs: { 'data-testid': 'email-customer-button' },
    },

    sendToPartLibrary: {
        id: 'sendToPartLibrary',
        label: 'Send to part library',
        handler: 'handleSendToPartLibrary',
        tagAttrs: { 'data-testid': 'send-to-part-library-button' },
    },
    duplicateQuote: {
        id: 'duplicateQuote',
        label: 'Duplicate quote',
        handler: 'handleDuplicateQuote',
        tagAttrs: { 'data-testid': 'duplicate-quote-button' },
    },
    resendInvoiceData: {
        id: 'resendInvoiceData',
        label: 'Resend invoice data',
        handler: 'handleResendInvoiceData',
        tagAttrs: { 'data-testid': 'resend-invoice-data-button' },
        hidden: (showRetryIntegration) => !showRetryIntegration,
    },
    sendToGoogleDrive: {
        id: 'sendToGoogleDrive',
        label: 'Send to Google Drive',
        handler: 'handleSendToGoogleDrive',
        tagAttrs: { 'data-testid': 'send-to-google-drive-button' },
        hidden: (showGoogleDriveIntegration) => !showGoogleDriveIntegration,
    },
}

export const QUOTE_STATE_TO_ACTION_MAP = (status, paymentStatus) => {
    let actions = null
    switch (status) {
        case QUOTE_STATUS_ARRAY.NotCalculated:
            actions = [
                QUOTE_ACTIONS.calculateQuote,
                QUOTE_ACTIONS.emailQuote,
                QUOTE_ACTIONS.markAsIssued,
                QUOTE_ACTIONS.copyQuoteLink,
                QUOTE_ACTIONS.sendToPartLibrary,
                QUOTE_ACTIONS.duplicateQuote,
            ]
            break
        case QUOTE_STATUS_ARRAY.Calculated:
            actions = [
                QUOTE_ACTIONS.reviewQuote,
                QUOTE_ACTIONS.emailQuote,
                QUOTE_ACTIONS.markAsIssued,
                QUOTE_ACTIONS.copyQuoteLink,
                QUOTE_ACTIONS.sendToPartLibrary,
                QUOTE_ACTIONS.duplicateQuote,
            ]
            break
        case QUOTE_STATUS_ARRAY.Draft:
            actions = [
                QUOTE_ACTIONS.markAsIssued,
                QUOTE_ACTIONS.editQuote,
                QUOTE_ACTIONS.emailQuote,
                QUOTE_ACTIONS.copyQuoteLink,
                QUOTE_ACTIONS.sendToPartLibrary,
                QUOTE_ACTIONS.duplicateQuote,
                QUOTE_ACTIONS.sendToGoogleDrive,
            ]
            break
        case QUOTE_STATUS_ARRAY.Issued:
            actions = [
                QUOTE_ACTIONS.markAsOrdered,
                ...(paymentStatus === QUOTE_PAYMENT_STATUS.Unpaid
                    ? [QUOTE_ACTIONS.markAsPaidAndOrdered]
                    : [QUOTE_ACTIONS.markAsUnpaid]),
                QUOTE_ACTIONS.editQuote,
                QUOTE_ACTIONS.emailQuote,
                QUOTE_ACTIONS.copyQuoteLink,
                QUOTE_ACTIONS.markAsLost,
                QUOTE_ACTIONS.sendToPartLibrary,
                QUOTE_ACTIONS.duplicateQuote,
                QUOTE_ACTIONS.sendToGoogleDrive,
            ]
            break
        case QUOTE_STATUS_ARRAY.PendingOrderConfirmation:
            actions = [
                QUOTE_ACTIONS.emailCustomer,
                QUOTE_ACTIONS.markAsConfirmed,
                ...(paymentStatus === QUOTE_PAYMENT_STATUS.Unpaid
                    ? [QUOTE_ACTIONS.markAsPaidAndOrdered]
                    : [QUOTE_ACTIONS.markAsUnpaid]),
                QUOTE_ACTIONS.editPendingOrder,

                QUOTE_ACTIONS.sendToGoogleDrive,
                QUOTE_ACTIONS.markAsRejected,
            ]
            break
        case QUOTE_STATUS_ARRAY.Ordered:
            actions = [
                QUOTE_ACTIONS.markAsInvoiced,
                ...(paymentStatus === QUOTE_PAYMENT_STATUS.Unpaid
                    ? [QUOTE_ACTIONS.markAsPaid]
                    : [QUOTE_ACTIONS.markAsUnpaid]),
                QUOTE_ACTIONS.emailOrder,
                QUOTE_ACTIONS.copyOrderLink,
                QUOTE_ACTIONS.emailProformaInvoice,
                QUOTE_ACTIONS.copyProformaLink,

                QUOTE_ACTIONS.markAsCancelled,
                QUOTE_ACTIONS.duplicateQuote,
                QUOTE_ACTIONS.sendToGoogleDrive,
            ]
            break
        case QUOTE_STATUS_ARRAY.Invoiced:
            actions = [
                QUOTE_ACTIONS.emailTaxInvoice,
                QUOTE_ACTIONS.copyInvoiceLink,
                ...(paymentStatus === QUOTE_PAYMENT_STATUS.Unpaid
                    ? [QUOTE_ACTIONS.markAsPaid]
                    : [QUOTE_ACTIONS.markAsUnpaid]),
                QUOTE_ACTIONS.markAsVoided,
                QUOTE_ACTIONS.duplicateQuote,
                QUOTE_ACTIONS.sendToGoogleDrive,
                QUOTE_ACTIONS.resendInvoiceData,
            ]
            break
        case QUOTE_STATUS_ARRAY.Lost:
            actions = [
                QUOTE_ACTIONS.editQuote,
                QUOTE_ACTIONS.emailCustomer,
                ...(paymentStatus === QUOTE_PAYMENT_STATUS.Unpaid
                    ? [QUOTE_ACTIONS.markAsPaidAndOrdered]
                    : [QUOTE_ACTIONS.markAsUnpaid]),
                QUOTE_ACTIONS.duplicateQuote,
            ]
            break
        case QUOTE_STATUS_ARRAY.Cancelled:
            actions = [QUOTE_ACTIONS.duplicateQuote]
            break
        case QUOTE_STATUS_ARRAY.Voided:
            actions = [QUOTE_ACTIONS.duplicateQuote]
            break
        case QUOTE_STATUS_ARRAY.Rejected:
            actions = [QUOTE_ACTIONS.emailCustomer, QUOTE_ACTIONS.markAsPending]
            break
        case QUOTE_STATUS_ARRAY.Dispatched:
            actions = [QUOTE_ACTIONS.markAsLost, QUOTE_ACTIONS.markAsCancelled]
            break
        default:
            actions = null
    }

    return actions
}

export const QUOTE_ADD_PARTS_OPTIONS = [
    {
        id: 'add2dParts',
        label: 'Upload 2D DXF or DWG files',
        handler: 'handleAdd2dParts',
        tagAttrs: { 'data-testid': 'add-2d-parts-button' },
        source: QUOTE_SOURCE_TYPES.Internal,
    },
    {
        id: 'add3dParts',
        label: 'Unfold 3D models',
        handler: 'handleAdd3dParts',
        tagAttrs: { 'data-testid': 'add-3d-parts-button' },
        source: QUOTE_SOURCE_TYPES.Internal,
    },
    {
        id: 'addRotaryParts',
        label: 'Upload tube models',
        handler: 'handleAddRotaryParts',
        tagAttrs: { 'data-testid': 'add-rotary-parts-button' },
        source: QUOTE_SOURCE_TYPES.Internal,
    },
    {
        id: 'addFromQuickParts',
        label: 'Create parts in Quick Part',
        handler: 'handleAddFromQuickParts',
        tagAttrs: { 'data-testid': 'add-from-quickpart-button' },
        source: QUOTE_SOURCE_TYPES.Internal,
    },
    {
        id: 'addPdfParts',
        label: 'Extract parts from PDFs',
        handler: 'handleAddPdfParts',
        tagAttrs: { 'data-testid': 'add-pdf-part-button' },
        source: QUOTE_SOURCE_TYPES.Internal,
    },
    {
        id: 'addFromPartsLibrary',
        label: 'Add parts from Part Library',
        handler: 'handleAddFromPartsLibrary',
        tagAttrs: { 'data-testid': 'add-from-part-library-button' },
        source: QUOTE_SOURCE_TYPES.Internal,
    },
    {
        id: 'addMiscellaneousItem',
        label: 'Add Miscellaneous Item',
        handler: 'handleAddMiscellaneousItem',
        tagAttrs: { 'data-testid': 'add-miscellaneous-item-button' },
        source: QUOTE_SOURCE_TYPES.Internal,
    },
]

export const WEBSTORE_QUOTE_ADD_PARTS_OPTIONS = [
    {
        id: 'add2dParts',
        label: 'Add 2D Parts',
        handler: 'handleAdd2dParts',
        tagAttrs: { 'data-testid': 'add-2d-parts-button' },
        source: QUOTE_SOURCE_TYPES.WebStore,
    },
    {
        id: 'addFromQuickParts',
        label: 'Add from Quick Part',
        handler: 'handleAddFromQuickParts',
        tagAttrs: { 'data-testid': 'add-from-quickpart-button' },
        source: QUOTE_SOURCE_TYPES.WebStore,
    },
    // {
    //     id: 'add3dParts',
    //     label: 'Add 3D Parts',
    //     handler: 'handleAdd3dParts',
    //     tagAttrs: { 'data-testid': 'add-3d-parts-button' },
    // },
    // {
    //     id: 'addRotaryParts',
    //     label: 'Add Rotary Parts',
    //     handler: 'handleAddRotaryParts',
    //     tagAttrs: { 'data-testid': 'add-rotary-parts-button' },
    // },
    // {
    //     id: 'addPdfParts',
    //     label: 'Add parts from PDF',
    //     handler: 'handleAddPdfParts',
    //     tagAttrs: { 'data-testid': 'add-pdf-part-button' },
    // },
    // {
    //     id: 'addFromPartsLibrary',
    //     label: 'Add from Part Library',
    //     handler: 'handleAddFromPartsLibrary',
    //     tagAttrs: { 'data-testid': 'add-from-part-library-button' },
    // },
]

const DOWNLOAD_DOCUMENTS_OPTIONS_KEYS_A = [
    QUOTE_STATUS_ARRAY.NotCalculated,
    QUOTE_STATUS_ARRAY.NotCalculated,
    QUOTE_STATUS_ARRAY.Draft,
    QUOTE_STATUS_ARRAY.Issued,
    QUOTE_STATUS_ARRAY.Lost,
    QUOTE_STATUS_ARRAY.PendingOrderConfirmation,
    QUOTE_STATUS_ARRAY.Rejected,
]

const DOWNLOAD_DOCUMENTS_OPTIONS_KEYS_B = [
    QUOTE_STATUS_ARRAY.Ordered,
    QUOTE_STATUS_ARRAY.Cancelled,
    QUOTE_STATUS_ARRAY.Voided,
]

export const QUOTE_DOWNLOAD_DOCUMENTS_OPTIONS = {
    ...Object.fromEntries(
        DOWNLOAD_DOCUMENTS_OPTIONS_KEYS_A.map((key) => [
            key,
            [
                {
                    id: PUBLIC_DOCUMENTS.Quote,
                    label: 'Quote',
                    disabled: false,
                    type: 'public',
                    tagAttrs: { 'data-testid': 'download-quote-button' },
                },
                {
                    id: PUBLIC_DOCUMENTS.OrderConfirmation,
                    label: 'Order confirmation',
                    disabled: true,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'public',
                    tagAttrs: { 'data-testid': 'download-order-confirmation-button' },
                },
                {
                    id: PUBLIC_DOCUMENTS.ProformaInvoice,
                    label: 'Proforma invoice',
                    disabled: true,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'public',
                    tagAttrs: { 'data-testid': 'download-proforma-invoice-button' },
                },
                {
                    id: PUBLIC_DOCUMENTS.TaxInvoice,
                    label: 'Tax invoice',
                    disabled: true,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'public',
                    tagAttrs: { 'data-testid': 'download-tax-invoice-button' },
                },
                {
                    id: PRIVATE_DOCUMENTS.WorkOrderSummary,
                    label: 'Work order summary',
                    disabled: true,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'private',
                    tagAttrs: { 'data-testid': 'download-work-order-summary-button' },
                },
                {
                    id: PRIVATE_DOCUMENTS.WorkOrder,
                    label: 'Work order',
                    disabled: true,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'private',
                    tagAttrs: { 'data-testid': 'download-work-order-button' },
                },
                {
                    id: PRIVATE_DOCUMENTS.DeliveryDocket,
                    label: 'Delivery docket',
                    disabled: true,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'private',
                    tagAttrs: { 'data-testid': 'download-delivery-docket-button' },
                },
                {
                    id: PRIVATE_DOCUMENTS.ProductionLabels,
                    label: 'Production labels',
                    disabled: true,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'private',
                    tagAttrs: { 'data-testid': 'download-production-labels-button' },
                },
            ],
        ])
    ),
    ...Object.fromEntries(
        DOWNLOAD_DOCUMENTS_OPTIONS_KEYS_B.map((key) => [
            key,
            [
                {
                    id: PUBLIC_DOCUMENTS.Quote,
                    label: 'Quote',
                    disabled: false,
                    type: 'public',
                    tagAttrs: { 'data-testid': 'download-quote-button' },
                },
                {
                    id: PUBLIC_DOCUMENTS.OrderConfirmation,
                    label: 'Order confirmation',
                    disabled: false,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'public',
                    tagAttrs: { 'data-testid': 'download-order-confirmation-button' },
                },
                {
                    id: PUBLIC_DOCUMENTS.ProformaInvoice,
                    label: 'Proforma invoice',
                    disabled: false,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'public',
                    tagAttrs: { 'data-testid': 'download-proforma-invoice-button' },
                },
                {
                    id: PUBLIC_DOCUMENTS.TaxInvoice,
                    label: 'Tax invoice',
                    disabled: true,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'public',
                    tagAttrs: { 'data-testid': 'download-tax-invoice-button' },
                },
                {
                    id: PRIVATE_DOCUMENTS.WorkOrderSummary,
                    label: 'Work order summary',
                    disabled: false,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'private',
                    tagAttrs: { 'data-testid': 'download-work-order-summary-button' },
                },
                {
                    id: PRIVATE_DOCUMENTS.WorkOrder,
                    label: 'Work order',
                    disabled: false,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'private',
                    tagAttrs: { 'data-testid': 'download-work-order-button' },
                },
                {
                    id: PRIVATE_DOCUMENTS.DeliveryDocket,
                    label: 'Delivery docket',
                    disabled: false,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'private',
                    tagAttrs: { 'data-testid': 'download-delivery-docket-button' },
                },
                {
                    id: PRIVATE_DOCUMENTS.ProductionLabels,
                    label: 'Production labels',
                    disabled: false,
                    hidden: import.meta.env.VITE_RESELLER ?? false,
                    type: 'private',
                    tagAttrs: { 'data-testid': 'download-production-labels-button' },
                },
            ],
        ])
    ),
    [QUOTE_STATUS_ARRAY.Invoiced]: [
        {
            id: PUBLIC_DOCUMENTS.Quote,
            label: 'Quote',
            disabled: false,
            type: 'public',
            tagAttrs: { 'data-testid': 'download-quote-button' },
        },
        {
            id: PUBLIC_DOCUMENTS.OrderConfirmation,
            label: 'Order confirmation',
            disabled: false,
            hidden: import.meta.env.VITE_RESELLER ?? false,
            type: 'public',
            tagAttrs: { 'data-testid': 'download-order-confirmation-button' },
        },
        {
            id: PUBLIC_DOCUMENTS.ProformaInvoice,
            label: 'Proforma invoice',
            disabled: false,
            hidden: import.meta.env.VITE_RESELLER ?? false,
            type: 'public',
            tagAttrs: { 'data-testid': 'download-proforma-invoice-button' },
        },
        {
            id: PUBLIC_DOCUMENTS.TaxInvoice,
            label: 'Tax invoice',
            disabled: false,
            hidden: import.meta.env.VITE_RESELLER ?? false,
            type: 'public',
            tagAttrs: { 'data-testid': 'download-tax-invoice-button' },
        },
        {
            id: PRIVATE_DOCUMENTS.WorkOrderSummary,
            label: 'Work order summary',
            disabled: false,
            hidden: import.meta.env.VITE_RESELLER ?? false,
            type: 'private',
            tagAttrs: { 'data-testid': 'download-work-order-summary-button' },
        },
        {
            id: PRIVATE_DOCUMENTS.WorkOrder,
            label: 'Work order',
            disabled: false,
            hidden: import.meta.env.VITE_RESELLER ?? false,
            type: 'private',
            tagAttrs: { 'data-testid': 'download-work-order-button' },
        },
        {
            id: PRIVATE_DOCUMENTS.DeliveryDocket,
            label: 'Delivery docket',
            disabled: false,
            hidden: import.meta.env.VITE_RESELLER ?? false,
            type: 'private',
            tagAttrs: { 'data-testid': 'download-delivery-docket-button' },
        },
        {
            id: PRIVATE_DOCUMENTS.ProductionLabels,
            label: 'Production labels',
            disabled: false,
            hidden: import.meta.env.VITE_RESELLER ?? false,
            type: 'private',
            tagAttrs: { 'data-testid': 'download-production-labels-button' },
        },
    ],
}

export const QUOTE_USER_TYPE = {
    Customer: 'Customer',
    Guest: 'Guest',
    Internal: 'Internal',
}

export const QUADERNO_JURISDICTIONS = [
    {
        country: 'BE',
        name: 'Belgica',
    },
    {
        country: 'BG',
        name: 'Bulgaria',
    },
    {
        country: 'CY',
        name: 'Cyprus',
    },
    {
        country: 'CZ',
        name: 'Czech Republic',
    },
    {
        country: 'DE',
        name: 'Germany',
    },
    {
        country: 'DK',
        name: 'Denmark',
    },
    {
        country: 'EE',
        name: 'Estonia',
    },
    {
        country: 'EL',
        name: 'Greece',
    },
    {
        country: 'ES',
        name: 'Spain',
    },
    {
        country: 'FI',
        name: 'Finland',
    },
    {
        country: 'FR',
        name: 'France',
    },
    {
        country: 'HR',
        name: 'Croatia',
    },
    {
        country: 'HU',
        name: 'Hungary',
    },
    {
        country: 'IE',
        name: 'Ireland',
    },
    {
        country: 'IT',
        name: 'Italy',
    },
    {
        country: 'LR',
        name: 'Lithuania',
    },
    {
        country: 'LU',
        name: 'Luxembourg',
    },
    {
        country: 'LV',
        name: 'Latvia',
    },
    {
        country: 'MT',
        name: 'Malta',
    },
    {
        country: 'NL',
        name: 'The Netherlands',
    },
    {
        country: 'PL',
        name: 'Poland',
    },
    {
        country: 'PT',
        name: 'Portugal',
    },
    {
        country: 'RO',
        name: 'Romania',
    },
    {
        country: 'SE',
        name: 'Sweden',
    },
    {
        country: 'SI',
        name: 'Slovenia',
    },
    {
        country: 'SK',
        name: 'Slovakia',
    },
    {
        country: 'XI',
        name: 'Northern Ireland',
    },
    {
        country: 'AU',
        name: 'Australia',
    },
    {
        country: 'GB',
        name: 'United Kingdom of Great Bretain and Northern Ireland',
    },
    {
        country: 'CH',
        name: 'Switzerland',
    },
    {
        country: 'NZ',
        name: 'New Zealand',
    },
    {
        country: 'CA',
        name: 'Canada',
    },
]

export const EXPORTABLE_CONTENT = 'exportable-content'
export const FOOTER_BRANDING = 'exportable-footer-branding'
export const FOOTER_SELECTOR = 'exportable-footer'
export const IS_EXPORTING_SELECTOR = 'exportable-is-exporting'

export const CUTTING_TECHNOLOGY_POWERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export const PARTS_PER_PAGE_VARIABLE = 'parts-per-page'
export const PARTS_PER_PAGE_DEFAULT_VALUE = 10
export const PARTS_PER_PAGE_OPTIONS = [10, 25, 50]

export const ITEMS_PER_PAGE_VARIABLE = 'items-per-page'
export const ITEMS_PER_PAGE_DEFAULT_VALUE = 5
export const ITEMS_PER_PAGE_OPTIONS = [5, 10, 25, 50]

export const USERS_PER_PAGE_VARIABLE = 'users-per-page'
export const USERS_PER_PAGE_DEFAULT_VALUE = 5
export const USERS_PER_PAGE_OPTIONS = [5, 10, 15]

export const TAX_RATES_PER_PAGE_VARIABLE = 'tax-rates-per-page'
export const TAX_RATES_PER_PAGE_DEFAULT_VALUE = 5
export const TAX_RATES_PER_PAGE_OPTIONS = [5, 10, 15]

export const INVOICES_PER_PAGE_VARIABLE = 'invoices-per-page'
export const INVOICES_PER_PAGE_DEFAULT_VALUE = 5
export const INVOICES_PER_PAGE_OPTIONS = [5, 10, 15]

export const ZONES_PER_PAGE_VARIABLE = 'zones-per-page'
export const ZONES_PER_PAGE_DEFAULT_VALUE = 5
export const ZONES_PER_PAGE_OPTIONS = [5, 10, 15]

export const CONTAINERS_PER_PAGE_VARIABLE = 'containers-per-page'
export const CONTAINERS_PER_PAGE_DEFAULT_VALUE = 5
export const CONTAINERS_PER_PAGE_OPTIONS = [5, 10, 15]

export const ZONE_CONTAINERS_PER_PAGE_VARIABLE = 'zone-containers-per-page'
export const ZONE_CONTAINERS_PER_PAGE_DEFAULT_VALUE = 5
export const ZONE_CONTAINERS_PER_PAGE_OPTIONS = [5, 10, 15]

export const DEFAULT_QUOTE_FOOTER = `Thank you for your enquiry. This estimate is valid for 30 days.
All items are subject to the availability and price of raw materials at the time of order.
Any revisions to this quotation may require a recalculation of price.`

export const DEFAULT_CONTACT_DETAILS = `Business name
Tax ID 1234567890
123 Sample Lane
City, State, Zip Code
+1 (123) 456-7890
sales@yourbusiness.com`

export const DEFAULT_PAYMENT_DETAILS = `Bank name: Big Bank
Routing number: 123456789
Account number 123456789000
SWIFT code: WWWFFF`

export const PROFORMA_INVOICE_NOTES = `This proforma invoice must be paid in full before work can commence.
Please note this is not a tax invoice. A full tax invoice will follow delivery of goods.`

export const LIBELLULA_PRICING_REDIRECT_URL = 'mailto:contact@libellula.eu'
export const TOOLBOX_PRICING_REDIRECT_URL = 'https://tempustools.com/contact-us/pricing-request/?stripe_customer_id='

export const COUNTRY_LANGUAGE_MAP = {
    AU: { locale: 'en-GB', language: 'English' },
    CA: { locale: 'en-US', language: 'English' },
    CL: { locale: 'es-ES', language: 'Spanish' },
    FR: { locale: 'fr-FR', language: 'French' },
    DE: { locale: 'de-DE', language: 'German' },
    IT: { locale: 'it-IT', language: 'Italian' },
    NZ: { locale: 'en-GB', language: 'English' },
    GB: { locale: 'en-GB', language: 'English' },
    US: { locale: 'en-US', language: 'English' },
    BR: { locale: 'pt-PT', language: 'Portuguese' },
    PT: { locale: 'pt-PT', language: 'Portuguese' },
}

export const DELIVERY_PRICING_METHODS = {
    SeparateCharge: {
        value: 'SeparateCharge',
        label: 'Charge the customer for delivery separately',
        shortLabel: 'Charge for delivery separately',
        documentLabel: 'Charged separately',
        helperText: 'Contact the customer after they have placed an order to arrange and pay for delivery separately.',
        sources: [QUOTE_SOURCE_TYPES.WebStore],
    },
    PayUponDelivery: {
        value: 'PayUponDelivery',
        label: 'Customer pays a delivery provider directly upon delivery',
        shortLabel: 'Customer pays a delivery provider',
        documentLabel: 'Payable to delivery provider',
        helperText:
            "Arrange for the delivery provider to invoice the customer directly for payment. Alternatively, the customer might authorise the delivery provider to charge the customer's delivery account number, if they have one.",
        sources: [QUOTE_SOURCE_TYPES.Internal, QUOTE_SOURCE_TYPES.WebStore],
    },
    ManualCharge: {
        value: 'ManualCharge',
        label: 'Charge for delivery manually',
        shortLabel: 'Charge manually',
        documentLabel: 'Included',
        helperText:
            'Determine your own price to charge for delivery, if any. Add that charge as a miscellaneous item, or build the delivery charge into the price of the parts.',
        sources: [QUOTE_SOURCE_TYPES.Internal],
    },
    ChargeToOrder: {
        value: 'ChargeToOrder',
        label: 'Use the smart shipping calculator',
        shortLabel: 'Smart shipping calculator',
        documentLabel: 'Included',
        helperText:
            'Use the smart shipping calculator to determine the delivery charge based on the delivery address, the weight and size of the parts, and the delivery method.',
        sources: [QUOTE_SOURCE_TYPES.Internal, QUOTE_SOURCE_TYPES.WebStore],
    },
}

export const DELIVERY_PRICING_OPTIONS = {
    Flat: {
        value: 'Flat',
        label: () => 'Flat price',
        helperText: () => 'Charge a flat price based on the container size and weight, and the delivery address zone.',
    },
    ByDistance: {
        value: 'ByDistance',
        label: (isImperial) => `Flat price + price per ${isImperial ? 'mile' : 'kilometre'}`,
        helperText: (isImperial) =>
            `Charge a price per ${isImperial ? 'mile' : 'kilometre'} between your address and the delivery address, based on the container size and weight, and the delivery address zone.`,
    },
    ByWeight: {
        value: 'ByWeight',
        label: (isImperial) => `Flat price + price per ${isImperial ? 'pound' : 'kilogram'}`,
        helperText: (isImperial) =>
            `Charge a price per ${isImperial ? 'pound' : 'kilogram'} based on the net weight of parts, container size, and the delivery address zone.`,
    },
}
